import React from 'react';

import Dialog from 'components/Dialog';
import TabPanel from 'components/TabPanel';
import Tabs from 'components/Tabs';

import {
    Props, renderGroupInformationPanel, renderGroupOwnerManagerPanel
} from './GroupSettingsRenderMethods';

class GroupSettingsModal extends React.Component<Props> {
  render() {
    return (
      <Dialog
        eventScreenName="GroupSettingsModal"
        className="GroupSettingsModal"
        title="Class settings"
        onRequestHide={this.props.onRequestHide}
        size="small">
        <Tabs tabAlign="center">
          <TabPanel title={<span>Information</span>}>
            {renderGroupInformationPanel(this.props)}
          </TabPanel>
          <TabPanel title={<span>Owners</span>}>
            {renderGroupOwnerManagerPanel(this.props.group)}
          </TabPanel>
        </Tabs>
      </Dialog>
    );
  }
}

export default GroupSettingsModal;
